import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { memo } from "react";
import ReactModal from "react-modal";

import { ReactComponent as CloseIcon } from "assets/icons/close.svg";
import Button from "components/Button";
import { useGetNotice } from "hooks/apis/notice";
import NoticeModal from "./NoticeModal";

const NoticeDetail = ({ noticeId }: { noticeId: number }) => {
  const modal = useModal();
  const { data } = useGetNotice({ id: noticeId, type: "notice" });

  const closeModal = () => {
    modal.hide();
    modal.reject();
  };

  const onBack = () => {
    closeModal();
    setTimeout(() => {
      NiceModal.show(NoticeModal);
    }, 100);
  };

  return (
    <ReactModal
      overlayClassName="overflow-auto flex fixed size-full top-0 left-0 z-30"
      className="bg-[rgba(0,0,0,0.2)] min-w-[1280px] min-h-[720px] flex justify-center items-center size-full outline-none"
      isOpen={modal.visible}
      onRequestClose={closeModal}
      onAfterClose={() => {
        modal.remove();
      }}
    >
      <main className="bg-white flex flex-col w-[50rem] h-[43.75rem] p-[1.875rem] rounded-md">
        <header className="flex justify-end w-full relative">
          <h2 className="absolute text-center inset-0 justify-self-center self-center font-bold text-24 leading-[1.375rem]">
            공지사항
          </h2>
          <button className="relative z-10" type="button" onClick={closeModal}>
            <CloseIcon className="size-[2.25rem]" />
          </button>
        </header>
        <section className="flex-1 flex flex-col overflow-hidden pt-[4.375rem] gap-[1.875rem]">
          <table className="block flex-1 overflow-hidden text-16 border border-gray w-full">
            <tbody className="flex flex-col h-full">
              <tr className="shrink-0 w-full flex items-center h-14 border-b border-gray">
                <th
                  scope="row"
                  className="h-full flex items-center px-6 text-left bg-lightGray w-[6.875rem]"
                >
                  제목
                </th>
                <td className="px-[1.875rem]">{data?.title}</td>
              </tr>
              <tr className="shrink-0 w-full flex items-center h-14 border-b border-gray">
                <th
                  scope="row"
                  className="h-full flex items-center px-6 text-left bg-lightGray w-[6.875rem]"
                >
                  작성자
                </th>
                <td className="px-[1.875rem]">{data?.author}</td>
              </tr>
              <tr className="shrink-0 w-full flex items-center h-14 border-b border-gray">
                <th
                  scope="row"
                  className="h-full flex items-center px-6 text-left bg-lightGray w-[6.875rem]"
                >
                  유형
                </th>
                <td className="px-[1.875rem]">{data?.type}</td>
              </tr>
              <tr className="size-full flex">
                <th
                  scope="row"
                  className="shrink-0 align-top pt-[0.938rem] px-6 text-left bg-lightGray w-[6.875rem]"
                >
                  내용
                </th>
                <td className="w-full px-[1.875rem] align-top whitespace-pre-wrap">
                  <div className="overflow-auto h-full py-[0.563rem] leading-normal">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: data?.content || "",
                      }}
                    />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div className="flex justify-end">
            <Button outline className="w-[10.688rem]" onClick={onBack}>
              목록
            </Button>
          </div>
        </section>
      </main>
    </ReactModal>
  );
};

const NoticeDetailModal = NiceModal.create(memo(NoticeDetail));
NoticeDetailModal.displayName = "NoticeDetailModal";

export default NoticeDetailModal;
